import { render, staticRenderFns } from "./GetEthTxForWithdraw.vue?vue&type=template&id=38bce273&scoped=true&"
import script from "./GetEthTxForWithdraw.vue?vue&type=script&lang=js&"
export * from "./GetEthTxForWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./GetEthTxForWithdraw.vue?vue&type=style&index=0&id=38bce273&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bce273",
  null
  
)

export default component.exports